import { ReactNode } from "react";
import "./sidebar.css";

interface SidebarProps {
  children: ReactNode;
}

export function Sidebar({ children }: SidebarProps) {
  return (
    <div className="sidebar">
      <div className="sidebar__content-wrapper">{children}</div>
    </div>
  );
}
